import type { ButtonHTMLAttributes, HTMLAttributes, InputHTMLAttributes, SelectHTMLAttributes, ReactNode } from 'react'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & { variant?: 'primary' | 'secondary' | 'tertiary'; compact?: boolean; full?: boolean }
export function Button({ variant = 'primary', compact, full, className = '', ...props }: ButtonProps) {
  return <button {...props} className={['button', `button-${variant}`, compact && 'compact', full && 'full', className].filter(Boolean).join(' ')} />
}

type InputProps = InputHTMLAttributes<HTMLInputElement> & { invalid?: boolean }
export function Input({ invalid, className = '', ...props }: InputProps) {
  const ariaInvalid = invalid || props['aria-invalid'] === true || props['aria-invalid'] === 'true'
  return <input {...props} aria-invalid={ariaInvalid || undefined} className={['ui-input', ariaInvalid && 'ui-input-invalid', className].filter(Boolean).join(' ')} />
}

export function Card({ children, className = '', ...props }: HTMLAttributes<HTMLDivElement> & { children: ReactNode }) {
  return <div {...props} className={['ui-card', className].filter(Boolean).join(' ')}>{children}</div>
}

export function Badge({ children, tone = 'neutral', className = '' }: { children: ReactNode; tone?: 'neutral' | 'success' | 'warning' | 'danger'; className?: string }) {
  return <span className={['ui-badge', `ui-badge-${tone}`, className].filter(Boolean).join(' ')}>{children}</span>
}

export function SectionHeader({ title, description, eyebrow, className = '' }: { title: string; description?: string; eyebrow?: string; className?: string }) {
  return <div className={['ui-section-header', className].filter(Boolean).join(' ')}>{eyebrow && <span className="section-label">{eyebrow}</span>}<h2>{title}</h2>{description && <p>{description}</p>}</div>
}

export function Select({ className = '', ...props }: SelectHTMLAttributes<HTMLSelectElement>) {
  return <select {...props} className={['ui-select', className].filter(Boolean).join(' ')} />
}
